import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_SubstanceAbuseAssessment = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_SubstanceAbuseAssessment' className='file-pdf-document'>

            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Case Number:</span>
                            <input type='text' id="txtCaseNumber" name="txtCaseNumber" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Case Worker:</span>
                            <input type='text' id="txtCaseWorker" name="txtCaseWorker" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Agency:</span>
                            <input type='text' id="txtAgency" name="txtAgency" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Tests Administered:</span>
                            <input type='text' id="txtTestsAdminsitered" name="txtAgency" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Evaluator:</span>
                            <input type='text' id="txtEvaluator" name="txtEvaluator" className='add-only' />
                        </td>
                    </tr>
                </table>

                <p>

                    <span className='eleHeader'>Presenting Problem:</span>
                    <textarea id="txtPresentingProblem" name="txtPresentingProblem" className='add-only'></textarea>

                </p>

                <p>

                    <span className='eleHeader'>Substance Use History:</span>
                    <span className='small'>(Include results of Urine Drug Screen in this section)</span>
                    <textarea id="txtSubUseHistory" name="txtSubUseHistory" className='add-only'></textarea>

                </p>

                <h4>SUBSTANCE ABUSE SUBTLE SCREENING INVENTORY (SASSI):</h4>

                <p>
                    <input type='text' id="txtSASSI_1" name="txtSASSI_1" className='add-only w-100 custom-add-only' /> scores on the SASSI do not meet the criteria for having a high probability of having a substance dependence disorder. While the overall results show the tests were valid and meaningful, they also show that &nbsp;<input type='text' id="txtSASSI_2" name="txtSASSI_2" className='add-only w-100 custom-add-only' /> has a “low probability of having a substance dependence disorder.”
                    <br />
                    
                     <b>OR</b>

                </p>
                <p>

                    <input type='text' id="txtSASSI_3" name="txtSASSI_3" className='add-only w-100 custom-add-only' /> scores on the SASSI do meet the criteria for having a high probability of having a substance dependence disorder. The overall results show the tests were valid and meaningful.
                </p>
                <p>
                    However, an analysis of &nbsp;<input type='text' id="txtSASSI_4" name="txtSASSI_4" className='add-only w-100 custom-add-only' /> scale scores indicates the <b>(Address any elevated scores and what they mean)</b>
                    <br />
                    <textarea id="txtSASSI_Address" name="txtSASSI_Address:" className='add-only'></textarea>

                </p>
                <p>
                    Generally, <input type='text' id="txtSASSI_5" name="txtSASSI_5" className='add-only w-100 custom-add-only' /> appeared to have completed the SASSI with thoughtful consideration, but did appear to respond in a <input type='text' id="txtSASSI_6" name="txtSASSI_6" className='add-only w-100 custom-add-only' />. His/Her elevated scores in the <input type='text' id="txtSASSI_7" name="txtSASSI_7" className='add-only w-100 custom-add-only' /> sub-scales are cause for concern; however, his/her overall results showed he/she has a low probability of having a substance-dependence disorder. Nevertheless, having the elevated <input type='text' id="txtSASSI_8" name="txtSASSI_8" className='add-only w-100 custom-add-only' /> sub-scale results <input type='text' id="txtSASSI_9" name="txtSASSI_9" className='add-only w-100 custom-add-only' /> could benefit from interventions such as substance abuse counseling to address past trauma from <input type='text' id="txtSASSI_10" name="txtSASSI_10" className='add-only w-100 custom-add-only' /> issues and to address current stressor that cause him/her to use/drink. Additionally, <input type='text' id="txtSASSI_11" name="txtSASSI_11" className='add-only w-100 custom-add-only' /> could benefit from the support of an Alcoholics/Narcotics Anonymous group.

                </p>

                <p>

                    <span className='eleHeader'>LEGAL HISTORY:</span>
                    <textarea id="txtLegalHistory" name="txtLegalHistory" className='add-only'></textarea>

                </p>

                <p>

                    <span className='eleHeader'>ADJUSTMENT AND FUNCTIONING: (Address any psychiatric/psychological treatment and medications if any in this section also.)</span>
                    <textarea id="txtAdjustFunct" name="txtAdjustFunct" className='add-only'></textarea>

                </p>

                <h4>SUMMARY AND CONCLUSIONS:</h4>
                <p>
                    Clinician feels it important to note that addiction is characterized by an increasing dependence on mood-altering substances such as alcohol, marijuana, prescription drugs, cocaine or heroin. The signs of addiction are increased tolerance, loss of control, continued use despite negative consequences, and an inability to stop. Addiction causes serious problems in the following areas: physical health, mental health, family, social, occupation, financial and legal. In the process of assessing an individual's addictive tendencies, one looks for three main factors: 
                    <ol>
                        <li>loss of control,</li>
                        <li>need or compulsion to indulge,</li>
                        <li>continued use despite adverse consequences.</li>
                    </ol> 
                </p>
                <p>
                    <input type='text' id="txtSumAndCon_1" name="txtSumAndCon_1" className='add-only  w-250 custom-add-only' /> has a history of <input type='text' id="txtSumAndCon_2" name="txtSumAndCon_2" className='add-only w-100 custom-add-only' />. Although  his/her testing scores
                    <select id="ddlTestingScoresDo" name="ddlTestingScoresDo" className='add-only  w-100 custom-add-only'>
                        <option></option>
                        <option>do</option>
                        <option>do not</option>
                    </select> &nbsp;
                    meet the criteria for having a high probability for having a substance dependence disorder, given his usage history and family background, therapeutic intervention seems warranted. New Heights Behavioral Consultants recommends the following for <input type='text' id="txtRecommendsFollowingFor" name="txtRecommendsFollowingFor" className='add-only w-100 custom-add-only' />:
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            1.<input type='text' id="txtSumAndCon_NewHeightsBehavioral1" name="txtSumAndCon_NewHeightsBehavioral1" className='add-only w-730 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            2.<input type='text' id="txtSumAndCon_NewHeightsBehavioral2" name="txtSumAndCon_NewHeightsBehavioral2" className='add-only w-730 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            3.<input type='text' id="txtSumAndCon_NewHeightsBehavioral3" name="txtSumAndCon_NewHeightsBehavioral3" className='add-only w-730 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            4.<input type='text' id="txtSumAndCon_NewHeightsBehavioral4" name="txtSumAndCon_NewHeightsBehavioral4" className='add-only w-730 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-600'>
                            &nbsp;
                        </td>
                        <td className='signature w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-'>
                            (NAME & Credentials) S/T<br />Substance Abuse Assessor<br />New Heights Behavioral Consultants, Inc.
                        </td>
                        <td className='small w-'>
                            Date
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-600'>
                            &nbsp;
                        </td>
                        <td className='signature w-150'>
                            &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-'>
                            Robert L. Clemons, M.S., LPC<br />Clinical Supervisor, GA License LPC #004041<br />New Heights Behavioral Consultant
                        </td>
                        <td className='small w-'>
                            Date
                        </td>
                    </tr>
                </table>


            </div>
        </form>

    )
} 
